import React from 'react';
import { FaGlobeAmericas, FaMicrophone, FaUserFriends, FaVideo, FaFileAlt, FaAd, FaEnvelope } from 'react-icons/fa';
import '../styles/ServicesPage.css';

const ServicesPage = () => {
  const services = [
    {
      id: 'ad-localization',
      icon: <FaAd />,
      title: 'Ad Localization',
      description: 'Transform your advertising campaigns for global markets with culturally-tuned dubbing that drives conversions and maximizes ROI.',
      features: [
        'Culturally adapted messaging',
        'Market-specific voice casting',
        'Quick turnaround for campaigns',
        'Higher conversion rates'
      ]
    },
    {
      id: 'dynamic-content',
      icon: <FaMicrophone />,
      title: 'Dynamic Content Optimization',
      description: 'Refresh and repurpose your existing ads with new hooks and messaging without costly reshoots or production delays.',
      features: [
        'Update messaging quickly',
        'Test different hooks',
        'Seasonal campaign updates',
        'No expensive reshoots needed'
      ]
    },
    {
      id: 'global-dubbing',
      icon: <FaGlobeAmericas />,
      title: 'Global Content Dubbing',
      description: 'Comprehensive dubbing services for all types of media content across multiple languages to reach international audiences.',
      features: [
        'High-quality voice talent',
        '28+ languages available',
        'Consistent brand voice',
        'Cultural context adaptation'
      ]
    },
    {
      id: 'production-savings',
      icon: <FaVideo />,
      title: 'Production Cost Savings',
      description: 'Eliminate expensive re-shoots while maintaining premium quality by dubbing your existing content for multiple regions.',
      features: [
        'Save up to 60% on costs',
        'Faster time to market',
        'Multiple language versions',
        'One-stop solution'
      ]
    }
  ];

  // Email protection function
  const revealEmail = (e) => {
    e.preventDefault();
    const name = 'coleman';
    const domain = 'dubbah';
    const tld = 'co';
    window.location.href = `mailto:${name}@${domain}.${tld}`;
  };

  return (
    <div className="services-page">
      <div className="services-hero">
        <div className="container">
          <h1>Our Services</h1>
          <p>Professional audio dubbing and content optimization solutions</p>
        </div>
      </div>

      <section className="services-intro">
        <div className="container">
          <h2>Maximize Your Global Impact</h2>
          <p>
            DUBBAH helps businesses transform existing content to reach international audiences with 
            minimal investment. Our team of expert voice talent and content specialists ensure your 
            message resonates with viewers in over 28 languages.
          </p>
          <div className="cta-container">
            <a href="#" onClick={revealEmail} className="primary-button">
              <FaEnvelope className="icon-margin-right" /> Get a Custom Quote
            </a>
          </div>
        </div>
      </section>

      <section className="services-list">
        <div className="container">
          <div className="services-grid">
            {services.map((service) => (
              <div key={service.id} className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <ul className="service-features">
                  {service.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="process">
        <div className="container">
          <h2>Our Process</h2>
          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">1</div>
              <h3>Initial Consultation</h3>
              <p>We analyze your content and target markets to maximize ROI potential.</p>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <h3>Content Optimization</h3>
              <p>Your message is adapted for cultural context while maintaining core brand elements.</p>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <h3>Professional Dubbing</h3>
              <p>Our studio team creates perfect audio that matches your visual content.</p>
            </div>
            <div className="process-step">
              <div className="step-number">4</div>
              <h3>Delivery & Launch</h3>
              <p>Receive ready-to-launch content in all your target languages.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="services-cta">
        <div className="container">
          <h2>Ready to Go Global?</h2>
          <p>Contact our team today to discuss your project and get a custom quote.</p>
          <a href="#" onClick={revealEmail} className="primary-button">
            <FaEnvelope className="icon-margin-right" /> Contact Us
          </a>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
